function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "#BFBBB7",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("path", {
  d: "M6.964 4.23H2.85a.396.396 0 0 0-.408.385V8.5c0 .212.183.385.408.385h4.113A.396.396 0 0 0 7.37 8.5V4.615a.396.396 0 0 0-.407-.384zm-.407 3.885h-3.3V5h3.3v3.115z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.186 1.923h-1.222V.77c0-.424-.366-.769-.815-.769H.814C.365 0 0 .345 0 .77v12.307C0 14.137.913 15 2.036 15h13.928C17.087 15 18 14.137 18 13.077V2.692c0-.424-.365-.769-.814-.769zm0 11.154c0 .636-.549 1.154-1.222 1.154H2.036c-.673 0-1.222-.518-1.222-1.154V.769H15.15V12.5c0 .53.457.962 1.018.962a.396.396 0 0 0 .408-.385.396.396 0 0 0-.408-.385c-.112 0-.203-.086-.203-.192V2.692h1.222v10.385z"
}));

var SvgReports = function SvgReports(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgReports, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/reports.b8314003.svg";
export { ForwardRef as ReactComponent };